var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#757575",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3582 7.35352C9.55345 7.15825 9.55342 6.84166 9.35814 6.64642C9.16286 6.45117 8.84628 6.4512 8.65103 6.64648L5.69961 9.59839C5.62662 9.65445 5.56955 9.7302 5.53632 9.81769C5.46349 9.99809 5.50019 10.2124 5.64642 10.3586L8.65103 13.3638C8.84628 13.559 9.16286 13.5591 9.35814 13.3638C9.55342 13.1686 9.55345 12.852 9.3582 12.6567L7.19701 10.4952H13.4967C13.7728 10.4952 13.9967 10.2713 13.9967 9.99517C13.9967 9.71902 13.7728 9.49517 13.4967 9.49517H7.21691L9.3582 7.35352Z",
    fill: "#1B1B1B",
    fillOpacity: 0.7
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusBack);
export default ForwardRef;